import TngDisbursementSettingPanel from "./tngDisbursementSettingPanel.container";

export default TngDisbursementSettingPanel;
